<template>
  <v-container fluid class="fondo-hero">
    <v-row justify="center" align="center" class="alto">
      <v-col cols="12" md="6">
        <vue-typed-js
          :strings="[
            'Excavaciones',
            'Movimiento de suelos',
            'Demoliciones',
            'Provisión de áridos',
            'Alquiler de equipos viales',
            'Alquiler de camiones'
          ]"
          :loop="true"
          :showCursor="true"
          :typeSpeed="70"
          class="altura-min mx-auto"
        >
          <h1 class="mx-2 text-h3 text-center white--text font-weight-thin">
            MÁS DE 15 AÑOS DE EXPERIENCIA EN
            <br class="mb-5" />

            <span
              class="typing text-sm-h2 text-xs-h3 mt-xs-6 mt-md-3 font-weight-bold"
            >
            </span>
          </h1>
        </vue-typed-js>
        <div class="text-center pt-10">
          <v-hover v-slot:default="{ hover }">
            <v-btn
              x-large
              outlined
              color="white"
              class="mr-sm-3 mr-xs-0"
              :class="hover ? 'btn-color' : ''"
              @click="$vuetify.goTo('#equipos', 500, 0)"
            >
              Equipamento
            </v-btn>
          </v-hover>

          <v-btn
            x-large
            text
            color="white"
            class="ml-sm-3 mr-xs-0"
            @click="$vuetify.goTo('#contact', 500, 0)"
          >
            contactanos
          </v-btn>
        </div>
        <div class="redes mx-auto">
          <v-btn
            text
            fab
            href="https://www.instagram.com/argecam.srl/"
            target="_blank"
            bottom
          >
            <v-icon x-large color="white">
              mdi-instagram
            </v-icon>
          </v-btn>
          <v-btn
            text
            fab
            href="https://www.facebook.com/Argecam-SRL-279391785494145"
            target="_blank"
            bottom
          >
            <v-icon x-large color="white">
              mdi-facebook
            </v-icon>
          </v-btn>
        </div>
      </v-col>
      <v-col cols="12" md="6" class="mr-0 pr-0 d-none d-md-inline">
        <v-img
          :src="require('@/assets/intro-hero.jpeg')"
          height="100vh"
          width="100%"
        >
        </v-img>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "Hero",
  data: () => ({
    typedjs: {
      cursorChar: "&block;",
      showCursor: true,
      loop: true,
      startDelay: 0
    }
  })
};
</script>

<style scoped>
.fondo-hero {
  background-image: linear-gradient(
    to bottom,
    #03123b,
    #0a2451,
    #123667,
    #194a7e,
    #205f95
  );
  position: relative;
}
.alto {
  height: 100vh;
  width: 100vw;
}
.texto-hero {
  width: 80%;
  text-align: center;
}
.redes {
  position: absolute;
  bottom: 5%;
  left: 40%;
}
.diagonal {
  position: absolute;
  height: 100%;
  width: 150px;
  margin-left: -55px;
  box-shadow: 10px 10px 20px rgba(0, 0, 0, 0.5);
  /* background: red; */
  background-image: linear-gradient(
    /* to bottom,
      #171f2e,
      #1a2332,
      #1e2736,
      #212c3b,
      #25303f */
      to bottom,
    #03123b,
    #0a2451,
    #123667,
    #194a7e,
    #205f95
  );
  transform: skewX(0deg);
  z-index: 9999;
}
.altura-min {
  min-height: 300px;
  width: 100%;
}
.btn-color {
  background-color: white;
  color: #171f2e !important;
  transition: all 0.3s ease-in;
}
@media (max-width: 960px) {
  .redes {
    left: 40%;
  }
}
</style>
